<!-- 物流运输单商品信息 -->
<template>
  <div class="goodsTabel">
    <vxe-table
      border
      resizable
      show-overflow
      :data="goodsTable"
      size="mini"
      ref="goodsTable"
      auto-resize
    >
      <vxe-table-column
        type="seq"
        width="60"
        field="deliveryDetailNo"
        :title="$t('transportOrderAdd.goodsTable.deliveryDetailNo')"
      ></vxe-table-column>
      <vxe-table-column
        type="seq"
        width="120"
        field="instructionNo"
        v-if="deliveryType == '1'"
        :title="$t('transportOrderAdd.goodsTable.instructionNo')"
      ></vxe-table-column>
      <vxe-table-column
        type="seq"
        width="120"
        field="salesLadingNo"
        v-if="deliveryType == '2'"
        :title="$t('transportOrderAdd.goodsTable.salesLadingNo')"
      ></vxe-table-column>
      <vxe-table-column
        type="seq"
        field="transferSlipNo"
        width="120"
        v-if="deliveryType == '3'"
        :title="$t('transportOrderAdd.goodsTable.transferSlipNo')"
      ></vxe-table-column>
      <vxe-table-column
        type="seq"
        width="120"
        field="otherNo"
        v-if="deliveryType == '4'"
        :title="$t('transportOrderAdd.goodsTable.otherNo')"
      ></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      >
        <template v-if="item.precision" v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row[item.prop], item.precision)
        }}</template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  export default {
    name: 'goodsTable',
    props: ['isEdit', 'allDetail', 'status'],
    mounted() {
      // this.getGoodsDeatil();
    },
    computed: {
      // 表格展示字段
      columnList() {
        return [
          {
            prop: 'providerName',
            label: this.$t('transportOrderAdd.goodsTable.providerName'),
            width: 120,
          },
          {
            prop: 'productNo',
            label: this.$t('transportOrderAdd.goodsTable.productNo'),
            width: 120,
          },
          {
            prop: 'productName',
            label: this.$t('transportOrderAdd.goodsTable.productName'),
            width: 120,
          },
          {
            prop: 'deliveryQuantity',
            label: this.$t('transportOrderAdd.goodsTable.deliveryQuantity'),
            width: 120,
            precision: this.$globalVar.qPoint,
          },
          {
            prop: 'contractUnitName',
            label: this.$t('transportOrderAdd.goodsTable.contractUnit'),
            width: 120,
          },
          {
            prop: 'packageNumber',
            label: this.$t('transportOrderAdd.goodsTable.packageNumber'),
            width: 120,
            precision: this.$globalVar.qPoint,
          },
          {
            prop: 'packageUnit',
            label: this.$t('transportOrderAdd.goodsTable.packageUnit'),
            width: 120,
          },
          {
            prop: 'mark',
            label: this.$t('transportOrderAdd.goodsTable.mark'),
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        goodsTable: [],
        deliveryType: '',
        goodsFormData: {
          deliveryDetailStr: [],
        },
        deliveryDetailStr: [],
      };
    },
    methods: {
      getGoodsDeatil(allDetail) {
        // 接口查取详情
        this.goodsTable = allDetail;
      },
      getTableDetail(detail) {
        this.deliveryType = detail.deliveryType;
        let data = [];
        if (detail.deliveryType && detail.list && detail.list.length != 0) {
          if (detail.deliveryType == '1') {
            // 发货指令
            detail.list.map((item) => {
              let obj = {
                deliveryDetailNo: '',
                instructionNo: item.instructionDetailNo,
                salesLadingNo: '',
                transferSlipNo: '',
                otherNo: '',
                providerName: item.providerName,
                providerNo: item.providerNo,
                productNo: item.productNo,
                productName: item.productDesc,
                deliveryQuantity: item.instructionNumber,
                contractUnit: item.unitName,
                packageNumber: item.unitNumber,
                packageUnit: item.packagingUnit,
                mark: item.mark,
              };
              data.push(obj);
            });
          } else if (detail.deliveryType == '2') {
            // 销售提单
            detail.list.map((item) => {
              let obj = {
                deliveryDetailNo: '',
                instructionNo: '',
                salesLadingNo: item.ladingDetailNo,
                transferSlipNo: '',
                otherNo: '',
                providerName: '',
                providerNo: '',
                productNo: item.productNo,
                productName: item.productDesc,
                deliveryQuantity: item.ladingQuantity,
                contractUnit: item.unitName,
                packageNumber: '',
                packageUnit: '',
                mark: '',
              };
              data.push(obj);
            });
          } else if (detail.deliveryType == '3') {
            // 库存调拨单号
            detail.list.map((item) => {
              let obj = {
                deliveryDetailNo: '',
                instructionNo: '',
                salesLadingNo: '',
                transferSlipNo: item.allotDetailNo,
                otherNo: '',
                providerName: item.partnerName,
                providerNo: item.partnerNo,
                productNo: item.productDetailNo,
                productName: item.productName,
                // 数量不确认
                deliveryQuantity: item.surplusQuantity,
                contractUnit: item.unitName,
                packageNumber: '',
                packageUnit: '',
                mark: '',
              };
              data.push(obj);
            });
          } else if (detail.deliveryType == '4') {
            // 其他单号
            detail.list.map((item) => {
              let obj = {
                deliveryDetailNo: '',
                instructionNo: '',
                salesLadingNo: '',
                transferSlipNo: '',
                otherNo: item.returnDetailNo,
                providerName: item.partnerName,
                providerNo: item.partnerNo,
                productNo: item.productNo,
                productName: item.productDesc,
                deliveryQuantity: item.returnQuantity,
                contractUnit: item.unitName,
                packageNumber: '',
                packageUnit: '',
                mark: '',
              };
              data.push(obj);
            });
          }
          this.goodsTable = data;
        } else {
          this.goodsTable = [];
        }
      },
      // 返回数据
      exportChildData() {
        this.deliveryDetailStr = [];
        this.$refs.goodsTable.getTableData().fullData.map((item) => {
          this.deliveryDetailStr.push(JSON.stringify(item));
        });
        this.goodsFormData.deliveryDetailStr = '[' + this.deliveryDetailStr.join(',') + ']';
        return this.goodsFormData;
      },
    },
  };
</script>
